import type { GQVmItem } from "@/admin/vm/VmsTable.tsx";
import { Badge } from "@/components/Badge.tsx";
import { ClipBoardTooltip } from "@/components/ClipBoardTooltip.tsx";
import { OsInfo } from "@/modules/compute/os/OsInfo.tsx";
import { notNull } from "@warrenio/utils/notNull";
import type { ReactNode } from "react";

export function ModalHeaderBlock({ item, children }: { item: GQVmItem; children?: ReactNode }) {
    const { name, uuid, os_name, os_version } = item;

    return (
        <div className="flex gap-3 items-center justify-between lightBlock">
            <div className="flex-grow VStack gap-1 children:min-h-1.5em">
                <div>
                    <b>{name}</b> - <ClipBoardTooltip>{uuid}</ClipBoardTooltip>
                </div>
                <OsInfo os={{ os_name: os_name!, os_version: os_version! }} />
                <MachineSizeInfo item={item} />
            </div>

            {children}
        </div>
    );
}

function MachineSizeInfo({ item }: { item: GQVmItem }) {
    const { vcpu, memory } = item;

    return (
        <div className="flex gap-0.25em">
            <Badge color="text">{vcpu} vCPU</Badge>
            <Badge color="text">{memory / 1024} GB</Badge>
            <Badge color="text">{getPrimaryStorage(item).size} GB</Badge>
        </div>
    );
}

function getPrimaryStorage(item: GQVmItem) {
    return notNull(notNull(item.storage).find((item) => item.primary));
}
